import { useToolActionLabel } from "../lib/toolActionLabel.js";

/**
 * Render a tool's humanized activity label (e.g. `yagni_workspace_search`
 * → "Searching workspace"). Shared by InlineChat, ChannelView and
 * ToolCallGroup so the labelling stays consistent across surfaces.
 */
export function ToolCallLabel({ toolName }: { toolName: string }) {
  const label = useToolActionLabel(toolName);
  return <>{label}</>;
}
